<div class="d-flex align-items-end flex-column bd-highlight flexContainer">
    <nav class="container bd-highlight">
        <div class="navDiv1">
            <div class="brandlogoDiv">
                <img id ="tcs_logo" role="img" aria-label="TCS logo" class="logo"  [src]="imageUrl">
            </div>
            <div class="headingDiv show1">
                <h1 role="heading" class="">Validate Letter of Authority (LOA)</h1>
            </div>
            <div class="flexCol">
                <img role="img" src="assets/images/TATA_Group_logo_white.svg" alt="TATA logo" class="nonDesert">
                <img role="img" src="assets/images/Desert_TATA_Group_logo_white.svg" alt="TATA logo"
                    class="desertSchema">

            </div>
        </div>
        <div class="headingDiv show2 mt-1">
            <h1 role="heading" class="">Validate Letter of Authority (LOA)</h1>
        </div>
    </nav>
    <main class="contianer mx-auto bd-highlight">
        <router-outlet></router-outlet>
    </main>
    <footer class="container mt-auto bd-highlight footer" role="contentinfo">
        <div class="brandlogoDiv">
            <img id ="tcs_logo_footer" role="img" aria-label="TCS logo" class="logo"  [src]="imageUrl">
        </div>
        <p>© 2026 Tata Consultancy Services Limited | All Rights Reserved | 
            <span class="tooltip-container">
            <a class="link tooltip-target"  data-bs-placement="bottom" target="_blank" role="link" aria-label="Accessibility Statement" href="https://www.tcs.com/tcs-accessibility-declaration">Accessibility Statement</a>
            <div class="tooltip-content">On clicking this, you will be redirected to https://www.tcs.com/</div>
            </span>
            <br>Build No : {{version}}</p>
    </footer>
</div>